import styled from "styled-components";
import PropTypes from "prop-types";

import { ProfileMenuDesktop } from "../ProfileMenuDesktop";
import { ProfileMenuMobile } from "../ProfileMenuMobile";

import { openMobileMenuStyles } from "../ProfileMenuMobile/styles";
import { Link } from "../SiteHeader/styles";

import {
    breakpoints,
    Flexbox,
    easingSeconds,
    colors,
    ButtonStyle,
    GrayButtonStyle
} from "../shared";

// for LoggedOutLinks
export const LoggedOutFlexbox = styled(Flexbox)``;

export const Join = styled(Link)`
    margin-left: 1rem;
    ${ButtonStyle};
    ${GrayButtonStyle};
    color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.darkTwo : `${colors.whiteDuplicate}!important`};
    text-decoration: none !important;
    /* this doesnt work without !important */

    @media (max-width: ${breakpoints.md}rem) {
        display: none;
    }

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
        &&,
        &.scrolledUp {
            background-color: ${colors.emptySearchBG};
            color: ${colors.darkTwo};

            &:hover {
                background-color: ${colors.charcoal};
                color: ${colors.emptySearchBG};
            }
        }
        
        /* when SiteHeader has scrolledDown class: */
        .scrolledDown & {
            background-color: ${colors.charcoalTwo};
            color: ${colors.whiteDuplicate};

            &:hover {
                background-color: ${colors.blackDuplicate};
                color: ${colors.veryLightPinkTwo};
            }
        }
    `}
`;

export const Login = styled(Link)`
    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
    /* when SiteHeader has scrolledDown class: */
    .scrolledDown & {
        color: ${colors.brownishGreyTwo};

        &:hover {
            color: ${colors.black};
        }
    }
`}
`;

// for LoggedInLinks
export const AvatarWrapper = styled.div`
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
`;

const UserAvatar = styled.img`
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    opacity: ${({ active }) => (active ? "0.6" : "1")};
    vertical-align: middle;
    transition: all ${easingSeconds};

    &:hover {
        opacity: 0.6;
    }
`;

UserAvatar.propTypes = {
    active: PropTypes.bool
};

export { UserAvatar };

// for ProfileMenu
const Wrapper = styled.div`
    ${ProfileMenuDesktop} {
        /* toggle menu */
        display: ${({ open }) => (open ? "block" : "none")};

        /* hide menu on smaller screens */
        @media (max-width: 75rem) {
            display: none;
        }
    }

    ${ProfileMenuMobile} {
        display: none;

        @media (max-width: 75rem) {
            /* toggle menu  */
            ${({ open }) => open && openMobileMenuStyles}
        }
    }

    /* Tablet +: */
    @media (min-width: 768px) {
        /* REMs wasnt working on iPad mini */
        position: relative;
        height: 28px;
        /* to prevent content bouncing when navigating from page to page */

        margin-top: 8px;
    }
`;

Wrapper.propTypes = {
    open: PropTypes.bool
};

export { Wrapper };
